<template>
  <div class="dynamic">
    <div class="dynamic_title">{{$t("homeAbout.dynamic")}}</div>
    <div class="dynamic_sub">{{$t("homeAbout.dynamicSub")}}</div>
    <div class="introduced">
      <div class="introduced_left">
        <div class="each" @click="handleNavigate('/four', index + 1)" v-for="(item,index) in companyDynamicsLeft" :key="index">
          <div class="picture">
            <img :src="item.img" alt=""/>
          </div>
          <div class="describes">
            <div class="title">{{item.title}}</div>
            <div class="details">{{item.profile}}</div>
            <div class="more">{{$t("homeAbout.lookMore")}}</div>
          </div>
        </div>
      </div>
      <div class="introduced_right">
        <div class="each" @click="handleNavigate('/four', index + 3)" v-for="(item,index) in companyDynamicsRight" :key="index" :class="{'marginBottom':companyDynamicsRight.length-1 === index}">
          <div class="picture">
            <img :src="item.img" alt=""/>
          </div>
          <div class="describes">
            <div class="title">{{item.title}}</div>
            <div class="details">{{item.profile}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    companyDynamicsLeft()
    {
      return [
        {
          title: this.$t("homeAbout.companyDynamics1Title"),
          profile:this.$t("homeAbout.companyDynamics1Profile"),
          img:require("@/assets/img/home/1748915455_bY9U.png")
        },
        {
          title: this.$t("homeAbout.companyDynamics2Title"),
          profile:this.$t("homeAbout.companyDynamics2Profile"),
          img:require("@/assets/img/home/1747038686_ybZ9.jpg")
        }
      ]
    },
    companyDynamicsRight()
    {
      return [
        {
          title: this.$t("homeAbout.companyDynamics3Title"),
          profile:this.$t("homeAbout.companyDynamics3Profile"),
          img:require("@/assets/img/home/1747038622_4Mqy.jpg")
        },
        {
          title: this.$t("homeAbout.companyDynamics4Title"),
          profile:this.$t("homeAbout.companyDynamics4Profile"),
          img:require("@/assets/img/home/1747038613_fg2C.jpg")
        },
        {
          title: this.$t("homeAbout.companyDynamics5Title"),
          profile:this.$t("homeAbout.companyDynamics5Profile"),
          img:require("@/assets/img/home/1747038602_8bST.jpg")
        }
      ]
    }
  },
  data(){
    return {
    }
  },
  methods: {
    handleNavigate(url, index)
    {
      this.$router.push(url + "?articleIndex=" + index)
    }
  }
}
</script>
<style lang="scss" scoped>
//晴天动态
.dynamic{
  position: relative;
  background: url("../../assets/img/home/1746602841_rvJN.jpg") no-repeat;
  background-size: 100% 100%;
  font-family: $font-family;
  @media screen and (max-width: 768px) {
    background:none;
  }
  .dynamic_title{
    text-align: center;
    color: #203040;
    font-size: $title-font-size;
    font-weight: bold;
    padding: 60px 0 0 30px;
    @media screen and (max-width: 768px) {
      font-size: $phone-title-font-size;
      margin-top:-1rem;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
    }
  }
  .dynamic_sub{
   text-align: center;
    color: #fccc0c;
    font-size: $subtitle-font-size;
    @media screen and (max-width: 768px) {
      font-size: $phone-subtitle-font-size;
      margin-top:-1rem;
      position: absolute;
      left:50%;
      transform: translateX(-50%);
      top: 4.5%;
    }
  }
  .introduced{
    padding: 80px 0 60px 0;
    margin: 0 300px;
    display: flex;
    @media screen and (max-width: 768px) {
      flex-wrap: wrap;
      margin:0px 1rem;
    }
    .introduced_left{
      display: flex;
      width: 60%;
      border-right: 1px solid rgba(0, 0, 0, .06);
      @media screen and (max-width: 768px) {
        width: 100%;
        border-right:none;
        display: flex;
        justify-content: space-between;
        margin-top:4rem;
      }
      .each{
        width: 346.5px;
        margin-right: 50px;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          width: 48%;
          margin-right:0;
        }
        .picture{
          width: 100%;
          height: 240px;
          overflow: hidden;
          @media screen and (max-width: 768px) {
            height: 10rem;
          }
          img{
            height: 100%;
            width: 100%;
          }
        }
        .describes{
          background: #ffffff;
          padding:1rem 1rem;
          @media screen and (max-width: 768px) {
            border: 1px solid #eeeeee;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            margin-left: 0px;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          .title{
            line-height: 24px;
            height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;
            font-size: 1.2rem;
            margin-bottom: 14px;
            display: block;
            @media screen and (max-width: 768px) {
              font-size: 1rem;
              height: 2rem;
              line-height: 2rem;
            }
          }
          .details{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-height: 24px;
            max-height: 48px;
            color: #6f6f6f;
            margin-bottom: 20px;
            height: 48px;
            font-size: 0.8rem;
            @media screen and (max-width: 768px) {
              font-size: 0.8rem;
              height: 10rem;
              line-height: 1.5rem;
              max-height: 4.5rem;
              margin-bottom: 0;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              color: rgb(127, 127, 127)
            }
          }
          .more{
            font-size: 14px;
            color: #999;
            display: flex;
            justify-content: space-between;
            align-items: center;
            @media screen and (max-width: 768px) {
              display: none;
            }
          }
        }
        &:hover{
          .describes{
            .title{
              color: #794bb7 !important;
            }
            .more{
              color: #794bb7 !important;
            }
          }
          img{
            transform: scale(1.1);
            transition: transform .5s;
          }
        }
      }
    }
    .introduced_right{
      width: 40%;
      display: flex;
      flex-direction: column;
      margin-left: 40px;
      @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        flex-direction:row;
        justify-content: space-between;
        width: 100%;
        margin-left:0;
        margin-top: 0.5rem;
      }
      .each{
        margin-bottom: 36px;
        cursor: pointer;
        &:hover{
          .describes{
            .title{
              color: #794bb7 !important;
            }
            .more{
              color: #794bb7 !important;
            }
          }
          img{
            transform: scale(1.1);
            transition: transform .5s;
          }
        }
      }
      .each,.marginBottom{
        display: flex;
        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          width: 48%;
          border: 1px solid #eeeeee;
          box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
        }
        .picture{
          width: 30%;
          height: 120px;
          overflow: hidden;
          @media screen and (max-width: 768px) {
            width: 100%;
            height: 10rem;
          }
          img{
            height: 100%;
            width: 100%;
          }
        }
        .describes{
          width: 70%;
          margin-left: 30px;
          @media screen and (max-width: 768px) {
            width: 100%;
            padding-top: 0.8rem;
            padding-bottom: 0.7rem;
            margin-left: 0px;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          .title{
            font-size: 0.96rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-break: auto;
            -webkit-box-orient: vertical;
            /* text-align: justify; */
            -webkit-line-clamp: 2;
            line-height: 24px;
            max-height: 48px;
            margin-bottom: 10px;
            color: #333;
            font-weight: bolder;
            @media screen and (max-width: 768px) {
              -webkit-line-clamp: 1;
              font-size: 1rem;
              max-height: 4rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              height: 2rem;
              line-height: 2rem;
            }
          }
          .details{
            font-size: 0.8rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-height: 24px;
            max-height: 48px;
            color: #6f6f6f;
            margin-bottom: 20px;
            height: 48px;
            @media screen and (max-width: 768px) {
              font-size: 0.8rem;
              height: 10rem;
              line-height: 1.5rem;
              max-height: 4.5rem;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              color: rgb(127, 127, 127);
            }
          }
        }
      }
      .marginBottom{
        margin-bottom: 0px;
      }
    }
  }
}
</style>
